import React from 'react';
import { MessageCircle, ArrowDown, Award, Zap, ShieldCheck, DollarSign } from 'lucide-react';
import { motion } from 'framer-motion';
import { useLang } from '../contexts/LanguageContext';
import { HeroWebsiteReel } from './HeroWebsiteReel';
const badgeIcons = [Award, Zap, ShieldCheck, DollarSign];
export function Hero() {
  const {
    t
  } = useLang();
  return <section className="relative min-h-[90vh] flex flex-col justify-center overflow-hidden" data-id="element-166" data-mp="129h37ug97cgl">
      {/* Animated website reel background */}
      <div className="absolute inset-0 bg-dark" data-id="element-167" data-mp="xbfk59itvd54"></div>
      <HeroWebsiteReel data-id="element-168" data-mp="x8jojrugd0ju" />
      {/* Dark scrim for readability */}
      <div className="absolute inset-0 bg-dark/70" data-id="element-169" data-mp="s9q93tvluzh1"></div>
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_rgba(10,10,10,0.85)_0%,_rgba(10,10,10,0.4)_70%)]" data-id="element-170" data-mp="ncq0bb7dfim8"></div>
      <div className="absolute inset-x-0 bottom-0 h-40 bg-gradient-to-t from-dark to-transparent" data-id="element-171" data-mp="3d2bj5ngruvuh"></div>

      {/* Content */}
      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 pt-32 pb-16 lg:pt-40 lg:pb-20 text-center" data-id="element-172" data-mp="384jur3fc5rv1">
        <motion.h1 initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="text-4xl md:text-6xl lg:text-7xl font-extrabold text-white tracking-tight mb-6 drop-shadow-2xl" data-id="element-173" data-mp="3o7lq5lizewmb">
          {t.hero.titleA}{' '}
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-gold-300 to-gold-600" data-id="element-174" data-mp="358zr0c70zfl1">
            {t.hero.titleHighlight}
          </span>
          <span className="block text-2xl md:text-4xl lg:text-5xl mt-4 text-gray-200 font-bold" data-id="element-175" data-mp="2qhqwboo9n411">
            {t.hero.titleSub}
          </span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2,
        ease: 'easeOut'
      }} className="text-lg md:text-xl text-gray-200 max-w-2xl mx-auto leading-relaxed drop-shadow-lg" data-id="element-176" data-mp="2hkgj3xrw14th">
          {t.hero.subtitleBefore}{' '}
          <strong className="text-white" data-id="element-177" data-mp="i9vpx0zl3uk9">{t.hero.subtitlePrice}</strong>{' '}
          {t.hero.subtitleAfter}
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4,
        ease: 'easeOut'
      }} className="mt-10 flex flex-col sm:flex-row justify-center items-center gap-4" data-id="element-178" data-mp="1b1fe6zb1fyt4">
          <a href="https://wa.me/447311754270?text=WEBSITE" target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto flex items-center justify-center px-8 py-4 text-base font-bold rounded-full text-dark bg-gold hover:bg-gold-400 transition-all transform hover:scale-105 shadow-[0_0_20px_rgba(212,175,55,0.3)]" data-id="element-179" data-mp="3lsp3hdsd4jef">
            <MessageCircle className="w-5 h-5 mr-2" data-id="element-180" data-mp="269zihte7qxoe" />
            {t.hero.ctaWhatsapp}
          </a>
          <a href="#portafolio" className="w-full sm:w-auto flex items-center justify-center px-8 py-4 text-base font-bold rounded-full text-white border border-white/30 bg-dark/40 backdrop-blur-sm hover:bg-white/10 transition-all" data-id="element-181" data-mp="2b0pmp3awkuhi">
            {t.hero.ctaWork} <ArrowDown className="w-4 h-4 ml-2" data-id="element-182" data-mp="2l0zyqkl7bvv3" />
          </a>
        </motion.div>

        {/* Trust badges */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 1,
        delay: 0.8
      }} className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-6 max-w-4xl mx-auto border-t border-white/10 pt-10" data-id="element-183" data-mp="2tzlfqbb0z2tr">
          {t.hero.badges.map((text, i) => {
          const Icon = badgeIcons[i];
          return <motion.div key={i} whileHover={{
            y: -5
          }} className="flex flex-col items-center justify-center p-4 rounded-2xl hover:bg-white/5 transition-colors cursor-default" data-id="element-184" data-mp="3vgvwyrmxhf5q" data-mpi={i}>
                <Icon className="w-8 h-8 text-gold mb-3" data-id="element-185" data-mp="3hphdkjp3zby5" />
                <span className="text-sm font-medium text-gray-300 text-center" data-id="element-186" data-mp="3hnxrudkoo8oz">
                  {text}
                </span>
              </motion.div>;
        })}
        </motion.div>
      </div>
    </section>;
}